import React from 'react';
import sort from 'fast-sort';
import styled from 'styled-components';

const Container = styled.div(props => `

    display: inline;
    padding-right: ${props.theme.padding.smaller};
`);

function Order(props){

    if(props.type === 'asc'){

        return <Container><i className="fas fa-sort-amount-down" /></Container>;
    }

    else if(props.type === 'desc'){

        return <Container><i className="fas fa-sort-amount-up" /></Container>;
    }

    return false;
}

const Table = styled.table(props => `

    width: 100%;
    border-collapse: separate;

    @media (max-width: ${props.theme.minWidth.tablet}){

        & thead {

            display: none;
        }

        &, & tbody, & tr, & td {

            display: block;
        }
    }

    margin-bottom: ${(props.styled && props.styled.marginBottom && (props.pagination === false || props.pages <= 1)) ? props.styled.marginBottom : '0'};
`);

const Titles = styled.tr(props => `

    & > td {

        border-top: 1px solid ${props.theme.backgroundColor.main.normal};
    }

    & > td:first-of-type {

        border-left: 1px solid ${props.theme.backgroundColor.main.normal};
    }

    & > td:last-of-type {

        border-right: 1px solid ${props.theme.backgroundColor.main.normal};
    }

    & > td:first-of-type {

        border-radius: ${props.theme.borderRadius.smaller} 0 0 0;
    }

    & > td:last-of-type {

        border-radius: 0 ${props.theme.borderRadius.smaller} 0 0;
    }
`);

const Title = styled.td(props => `

    padding: ${props.theme.padding.normal};
    background: linear-gradient(${props.theme.backgroundColor.main.light}, ${props.theme.backgroundColor.main.normal});
    color: ${props.theme.color.main.normal};
`);

const Row = styled.tr(props => {

    return `

    background: #fff;

    & > td:first-of-type {

        border-top: 1px solid ${props.theme.borderColor.main.normal};
    }

    & > td:last-of-type {

        margin-bottom: ${props.theme.margin.normal};
    }

    & > td {

        border-left: 1px solid ${props.theme.borderColor.main.normal};
        border-right: 1px solid ${props.theme.borderColor.main.normal};
        border-bottom: 1px solid ${props.theme.borderColor.main.normal};
    }

    @media (min-width: ${props.theme.minWidth.tablet}){

        & > td:first-of-type {

            border-top: 0;
        }

        & > td:last-of-type {

            margin-bottom: 0;
        }

        & td {

            border: 0;
        }

        & > td {

            border-bottom: 1px solid ${props.theme.borderColor.main.normal};
        }

        & > td:first-of-type {

            border-left: 1px solid ${props.theme.borderColor.main.normal};
        }

        & > td:last-of-type {

            border-right: 1px solid ${props.theme.borderColor.main.normal};
        }

        &:last-of-type > td:first-of-type {

            ${props.pagination === false && `border-radius: 0 0 0 ${props.theme.borderRadius.smaller};`}
        }

        &:last-of-type > td:last-of-type {

            ${props.pagination === false && `border-radius: 0 0 ${props.theme.borderRadius.smaller} 0;`}
        }

        ${props.pagination === true && `

            &:last-of-type > td {

                border-bottom: 0;
            }
        `}
    }
`;});

const Column = styled.td(props => `

    padding: ${props.theme.padding.normal};
    vertical-align: middle;

    @media (max-width: ${props.theme.minWidth.tablet}){

        text-align: right;

        ${props.title !== undefined && `

            &:before {

                float: left;
                content: '${props.title !== '' ? props.title + ':': ''}';
            }
        `}
    }
`);

const Pagination = styled.div(props => `
    
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(${props.theme.backgroundColor.main.light}, ${props.theme.backgroundColor.main.normal});
    color: ${props.theme.color.grays.white};
    padding: ${props.theme.padding.normal};
    margin-bottom: ${(props.styled && props.styled.marginBottom) ? props.styled.marginBottom : '0'};
    border-radius: 0 0 ${props.theme.borderRadius.normal} ${props.theme.borderRadius.normal};
`);

const ChangePage = styled.div`

    ${props => `

        display: flex;
        align-items: center;
        justify-content: center;
        width: ${props.theme.width.normal};
        height: ${props.theme.height.normal};
        background: linear-gradient(${props.theme.backgroundColor.sub.light}, ${props.theme.backgroundColor.sub.normal});
        border: 1px solid ${props.theme.backgroundColor.sub.normal};
        border-radius: ${props.theme.borderRadius.smaller};
        cursor: pointer;

        &:hover {

            background: linear-gradient(${props.theme.backgroundColor.positive.light}, ${props.theme.backgroundColor.positive.normal});
            border: 1px solid ${props.theme.backgroundColor.positive.normal};
        }
    `}
`;

const Sort = styled.div`

    cursor: pointer;
`;

const CurrentPage = styled.span`

    ${props => `
   
        margin-left: ${props.theme.margin.normal};
        margin-right: ${props.theme.margin.normal};
    `}
`;

class LightTable extends React.Component {

    constructor(props){

        super(props);

        const first = Object.keys(this.props.headers)[0];
        const header = this.props.headers[first];

        const defaultSort = this.props.defaultSort !== undefined ? this.props.defaultSort : header === false ? false : first;
        const defaultOrder = this.props.defaultOrder !== undefined ? this.props.defaultOrder : 'asc';

        this.state = {

            page: 0,
            sort: defaultSort,
            order: defaultOrder
        }
    }

    resetBenchmark = () => {

        this.resetTime = Date.now();
    }

    benchmark = () => {

        let difference = Date.now() - this.resetTime;

        console.log('Benchmark: ' + difference + ' ms, Items: ' + this.props.data.length);
    }

    sortBy = key => {

        const order = this.state.sort !== key ? 'asc' : this.state.order === 'asc' ? 'desc' : 'asc';

        this.setState({

            sort: key,
            order: order
        });
    }

    sort = (data, field, order) => {

        const options = {

            comparer: new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }).compare
        };

        if(order === 'asc'){

            options.asc = v => v[field];
        }

        else if(order === 'desc'){

            options.desc = v => v[field];
        }

        return sort(data).by(options);
    }

    pagination = data => {

        const pages = this.props.pagination;

        if(pages === false){

            return data;
        }

        const from = this.state.page * pages;
        const to = from + pages;

        data = data.filter((v, k) => {

            if(k >= from & k < to){

                return true;
            }

            return false;
        });

        return data;
    }

    // Arrange data in same order than headers.

    arrange = (values) => {

        values = new Map(values);

        const arranged = [];

        for(let key in this.props.headers){

            arranged.push([key, values.get(key)]);
        }

        return arranged;
    }

    changePage = page => {

        this.setState({

            page: this.state.page + page
        });
    }

    get total(){

        if(this.props.pagination === false){

            return 1;
        }

        return Math.ceil(this.props.data.length / this.props.pagination);
    }

    modify = (key, row) => {

        const modifiers = this.props.modifiers || {};

        if(modifiers[key] !== undefined){

            return modifiers[key](key, row);
        }

        return row[key];
    }

    hasPagination = () => {

        if(this.props.pagination === false || this.props.data.length <= parseInt(this.props.pagination)){

            return false;
        }

        return true;
    }

    render(){

        if(this.props.data === undefined || this.props.data.length === 0){

            return false;
        }

        this.resetBenchmark();

        let data = this.props.data;

        data = this.sort(data, this.state.sort, this.state.order);
        data = this.pagination(data);

        let headers = Array.from(new Map(Object.entries(this.props.headers)));
        let keys = [];

        return (

            <React.Fragment>

                <Table breakpoint={this.props.breakpoint} styled={this.props.styled} pagination={this.props.pagination} pages={this.total}>

                    <thead>

                        <Titles>

                            {headers.map((header) => {

                                keys.push(header[0]);

                                return (

                                    <Title key={header[0]}>

                                        <Sort onClick={() => this.sortBy(header[0])}>

                                            {this.state.sort === header[0] && <Order type={this.state.order} />}
                                            {header[1] !== false && header[1] + ':'}

                                        </Sort>

                                    </Title>
                                );
                            })}

                        </Titles>

                    </thead>

                    <tbody>

                        {data.map((row, i) => {

                            let values = Array.from(new Map(Object.entries(row))).filter(v => {

                                // Filter out fields that are not included in headers.

                                if(keys.indexOf(v[0]) === -1){

                                    return false;
                                }

                                return true;
                            });

                            // Use id as key if it is set.

                            const key = row.id !== undefined ? row.id : i;

                            return (

                                <Row key={key} breakpoint={this.props.breakpoint} pagination={this.hasPagination()}>

                                    {this.arrange(values).map((v) => {

                                        const title = this.props.headers[v[0]];

                                        return <Column key={v[0]} title={title !== false ? title : ''} breakpoint={this.props.breakpoint}>{this.modify(v[0], row)}</Column>;
                                    })}
                               
                                </Row>
                            );
                        })}

                    </tbody>

                    {this.props.benchmark === true && [0].map(() => this.benchmark())}

                </Table>

                {this.hasPagination() === true &&

                    <Pagination styled={this.props.styled}>

                        {this.state.page > 0 && <ChangePage onClick={() => this.changePage(-1)}><i className="fas fa-caret-left" /></ChangePage>}
                        <CurrentPage>{this.state.page + 1} / {this.total}</CurrentPage>
                        {this.state.page + 1 < this.total && <ChangePage onClick={() => this.changePage(1)}><i className="fas fa-caret-right" /></ChangePage>}

                    </Pagination>
                }

            </React.Fragment>
        );
    }
}

LightTable.defaultProps = {

    benchmark: false,
    pagination: false,
    breakpoint: '1000px'
}

export default LightTable;
